import * as React from 'react'

import { Select } from '../../components'
import { formatFiscalName } from './utils'

interface Props {
  selected: string
  fiscalPeriods: string[]
  onSelect: (fiscalPeriod: string) => void
}

export function FiscalPeriodSelector(props: Props) {
  const [selected, setSelected] = React.useState(props.selected)

  React.useEffect(() => {
    setSelected(props.selected)
  }, [props.selected])

  const fiscalPeriods = React.useMemo(
    () =>
      props.fiscalPeriods.map((fiscalPeriod) => ({
        value: fiscalPeriod,
        label: formatFiscalName(fiscalPeriod),
      })),
    [props.fiscalPeriods]
  )

  return (
    <Select
      aria-label="Fiscal period"
      size="small"
      className="w-full"
      value={selected}
      items={fiscalPeriods}
      onChange={(item) => {
        setSelected(item.value)
        props.onSelect(item.value)
      }}
      isLoading={false}
    />
  )
}
